
































import { Component, Vue } from 'vue-property-decorator';
import EyeIcon from './EyeIcon.vue';
import { checkPasswordRules, DEFAULT_PASSWORD_RULES, PasswordRuleCheck } from '../../utils/password-rules';

@Component({
  components: { EyeIcon },
  props: {
    hasRules: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Object,
      default: () => DEFAULT_PASSWORD_RULES
    },
    inputLabel: {
      type: String,
      default: 'Password'
    },
    isIncorrect: {
      type: Boolean,
      default: false
    }
  }
})
export default class PasswordField extends Vue {
  showPassword = false;

  password = '';

  get passwordInputType(): string {
    return this.showPassword ? 'text' : 'password';
  }

  eyeClickHandler(value: boolean) {
    this.showPassword = !value;
  }

  get ruleChecks(): PasswordRuleCheck[] {
    return checkPasswordRules(this.password, this.$props.rules);
  }

  passwordInputHandler(password: string): void {
    this.password = password;
    this.$emit('updated', password);
    this.$emit('validated', this.validatePassword());
  }

  validatePassword(): boolean {
    return !this.$props.hasRules || this.ruleChecks.every(check => check.isMet);
  }

  hideErrorMessage(): void {
    this.$emit('hidePasswordErrorMessage', true);
  }
}
